import type { ComponentProps } from 'react';
import HubertCombobox from 'components/HubertUI/HubertCombobox';
import type { TSelectBase } from 'types/general.types';
import { useVisibilityLabels } from 'utils/visibilityLabels';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  items?: TSelectBase[];
}

const VisibilityCombobox = ({ isMulti = false, onValueChange, value, disabled = false, items, ...props }: Props) => {
  const { visibilityItems, visibilityItemName } = useVisibilityLabels();
  return (
    <div {...props}>
      <HubertCombobox
        itemName={visibilityItemName}
        isMulti={isMulti}
        items={items || visibilityItems}
        // These options are a scope ladder (widest to narrowest); the combobox's default
        // alphabetical sort would scramble that differently in every language.
        defaultSort={false}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default VisibilityCombobox;
